export default "__VITE_ASSET__C9z8$sEt__"